import { Fragment } from 'react';
import IconText from '/@/components/icon-text';
import { _ } from '/@/locale';

const ProductBenefits = ({ benefits, refuge }) => {
    return (
        <Fragment>
            {benefits &&
                benefits.map((benefit, index) => {
                    return (
                        <IconText
                            key={index}
                            text={refuge ? _(benefit) : _(benefit.description)}
                            withTheme
                            separation
                        />
                    );
                })}
        </Fragment>
    );
};

export default ProductBenefits;
